import type { SVGProps } from 'react';

export function LedgerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.3 16.5a.5.5 0 0 1 .5.5v1.7a.5.5 0 0 0 .5.5H7a.5.5 0 0 1 .5.5v.8a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5V17a.5.5 0 0 1 .5-.5zm16.2 0a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5v-.8a.5.5 0 0 1 .5-.5h1.7a.5.5 0 0 0 .5-.5V17a.5.5 0 0 1 .5-.5zM7 3a.5.5 0 0 1 .5.5v.8a.5.5 0 0 1-.5.5H5.3a.5.5 0 0 0-.5.5V7a.5.5 0 0 1-.5.5h-.8A.5.5 0 0 1 3 7V3.5a.5.5 0 0 1 .5-.5zm13.5 0a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5h-.8a.5.5 0 0 1-.5-.5V5.3a.5.5 0 0 0-.5-.5H17a.5.5 0 0 1-.5-.5v-.8A.5.5 0 0 1 17 3zM15.5 16a.5.5 0 0 1-.5.5H9.5A.5.5 0 0 1 9 16V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V14a.5.5 0 0 0 .5.5H15a.5.5 0 0 1 .5.5z" />
    </svg>
  );
}
